import { Modal } from 'antd';
import React from 'react';
import HSButton from '../../../../common/Button';

type Props = {
    open: boolean;
    setOpen: (t: boolean) => void;
    onConfirm: () => void;
};

const NDAConfirm: React.FC<Props> = ({ open, setOpen, onConfirm }) => {
    const onClickClose = () => {
        setOpen(false);
    };

    return (
        <Modal
            title="Non-Disclosure Agreement"
            open={open}
            onOk={onConfirm}
            onCancel={onClickClose}
            footer={null}
            centered
            className="onboarding_NDA_POP"
        >
            <div className="flex justify-center items-center m-4">
                <p className="text-base font-[WorkSans] text-center text-[#20222B]">
                    Please click “Confirm” if you accept the terms of the Non-Disclosure Agreement. Please note that you
                    may be required to sign an additional Non-Disclosure Agreement for select transactions.
                </p>
            </div>
            <div className="p-2 flex justify-center items-center">
                <HSButton
                    light
                    title="Cancel"
                    className="mr-4 WorkSans onboarding_btn_modal_close"
                    onClick={onClickClose}
                />
                <HSButton title="Confirm" onClick={onConfirm} className="onboarding_btn_modal" />
            </div>
        </Modal>
    );
};

export default NDAConfirm;
